import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchLiveSessions = async () => {
  const response = await fetch(`${API_BASE_URL}/live-sessions`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createLiveSession = async (sessionData) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(sessionData)
  });
  return handleResponse(response);
};

export const startLiveSession = async (id) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${id}/start`, {
    method: 'PUT',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const endLiveSession = async (id) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${id}/end`, {
    method: 'PUT',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchChatMessages = async (sessionId) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${sessionId}/chats`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const sendChatMessage = async (sessionId, chatMessageData) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${sessionId}/chats`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(chatMessageData)
  });
  return handleResponse(response);
};

export const sendViewerHeartbeat = async (sessionId, heartbeatData) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${sessionId}/heartbeat`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(heartbeatData)
  });
  return handleResponse(response);
};

export const fetchActiveViewers = async (sessionId) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${sessionId}/viewers`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const submitViewerSignal = async (sessionId, viewerId, signalData) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${sessionId}/viewers/${viewerId}/signal`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(signalData)
  });
  return handleResponse(response);
};

export const extendLiveSession = async (id) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${id}/extend`, {
    method: 'PUT',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchVideoSDKToken = async () => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/videosdk/token`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const updateVideoSDKMeetingId = async (id, meetingId) => {
  const response = await fetch(`${API_BASE_URL}/live-sessions/${id}/videosdk-meeting`, {
    method: 'PATCH',
    headers: getHeaders(),
    body: JSON.stringify({ videosdk_meeting_id: meetingId })
  });
  return handleResponse(response);
};
